<template>
  <div>
    <va-modal
      v-model="showModal"
      :no-outside-dismiss="true"
      id="externalPatientCodeSentModal"
      ref="externalPatientCodeSentModal"
      :showCancel="false"
      :showOkay="false"
      size="medium"
      @cancel="handleCancel"
      :fixed-layout="true">

      <div slot="header" class="text-center mb-0">

        <h3 style="color: black; font-weight: bolder"> {{ $t('ranu.records.search_external_patient') }} </h3>
        <div class="mt-4">
          <h4 style="color: #6E6E6E; font-weight: bolder"> {{ $t('ranu.records.code_sent_successfully') }}</h4>
        </div>
      </div>

      <form class="evollu-form pt-0">
        <div v-if="isLoading" class="my-4 py-4 d-flex flex-column justify-content-center align-items-center">
          <h6><b>{{ $t('kiosks.is_loading') }}</b></h6>
          <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
        </div>
        <div class="mb-5 text-center" v-if="!validatedSuccessfully && !isLoading">
          <span>{{ $t('ranu.records.did_not_receive_code') }}</span>&nbsp;
          <span
            class="clickable_label clickable"
            @click="handleResendCode">
            {{ $t('ranu.records.click_here') }}
          </span>
        </div>

        <div v-if="validatedSuccessfully">
          <div class="custom-box">
            <div class="mt-4 ml-5 mb-5">
              <div class="row d-inline">
                <i class="fa fa-check-circle evollu-color"/>
                &nbsp;
                <span class="evollu-color is-bold">{{ $t('ranu.records.validation_success') }}</span>
              </div>
              <div class="mt-2">
                <span class="is-bold"> {{ $t('ranu.records.proceed_to_consultation') }}</span>
              </div>
            </div>
          </div>

          <div class="text-center mb-5">
            <va-button
              class="validate-btn" @click.prevent="handleConsult"><span
              class="pl-3 pr-3">{{ $t('ranu.records.consult') }}</span>
            </va-button>
          </div>

        </div>
        <div class="custom-box text-center" v-else>
          <h6 class="mt-3" style="color: black; font-weight: bold">{{ $t('ranu.records.insert_validation_code') }}</h6>
          <div class="row row-validation">
            <va-input
              class="mr-5"
              id=validation-code-input
              :placeholder="$t('ranu.records.validation_code')"
              v-model="form.data.access_code"
              :maxlength="6"
              @input="form.errors.clear('access_code')"
              :error="form.errors.has('access_code')"
              :error-messages="[$t(form.errors.get('access_code'))]"
            />

            <va-button
              class="validate-btn" @click.prevent="handleConfirmValidationCode"><span
              class="pl-3 pr-3">{{ $t('ranu.records.validate') }}</span>
            </va-button>
          </div>
        </div>
      </form>

    </va-modal>
  </div>

</template>

<script>
import DatePicker from '@/components/common/DatePicker'
import Errors from '@/utils/StandardErrors'
import { AuthenticationService, RecordsService } from '@/api/RanuService'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'

const errorsPrefix = 'ranu.records.errors.'

export default {
  props: {
    access_code: {
      type: Object,
      required: true,
    },
  },
  components: { LoadingAnimation, DatePicker },
  data () {
    return {
      showModal: false,
      isLoading: false,
      form: {
        data: {
          access_code: null
        },
        errors: new Errors()
      },
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handleCancel: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('canceled')
      }, 250)
    },
    handleConfirmValidationCode: function () {
      AuthenticationService.validateCode(this.access_code, this.form.data)
        .then(() => {
          this.access_code.validated_at = new Date()
        })
        .catch(errors => {
          this.form.errors.record(errors.response.data.errors, errorsPrefix)
        })
    },
    handleConsult: function () {
      RecordsService.copy(this.access_code, this.$auth.user())
        .then((response) => {
          const record = response.data.data
          if (!(record && record.id)) {
            return
          }
          this.record = record
        })
        .finally(() => {
          this.showModal = false
          setTimeout(() => {
            this.$emit('consult', this.record)
          }, 250)
        })
    },
    handleResendCode: async function () {
      this.isLoading = true
      try {
        await AuthenticationService.resendCode(this.access_code)
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
  },
  computed: {
    validatedSuccessfully: function () {
      return this.access_code && this.access_code.validated_at && this.moment(this.access_code.validated_at).isSameOrBefore(this.access_code.valid_until)
    }
  }
}
</script>

<style lang="scss">

.custom-box {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 60px;
  border: 4px solid #E8E8E8;
  border-top-color: #29C4AA;
}

.clickable_label {
  color: #29C4AA;
}

.evollu-color {
  color: #29C4AA;
}

.validate-btn {
  line-height: 0;
  margin-top: 0;
}

.row-validation {
  margin-top: 20px;
  margin-left: 70px;
  margin-right: 100px;
}

</style>
